<template>
  <v-container grid-list-md text-xs-center fluid>
    <h3 style="text-align: center">
      <v-icon
        style="margin-top: 10%; font-size: 128px"
        dark
        left
        class="primary--text"
        >warning</v-icon
      >
    </h3>
    <h3 style="text-align: center">
      You Don't have Permission to view this page.
    </h3>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PermissionDenied/PermissionDenied.vue